<template lang="pug">
  #CustomerUsersModel.CustomerModel.CustomerModel-usersModel.overflow-hidden(
    :class="{ 'CustomerModel-active': showModel }"
  )
    .content-header.modal_header.rounded-bottom-1rem.pt-0(
      style="height: 50px;"
    )
      .row.align-items-center.h-100
        .col-10
          h5.mb-0 {{ title }}
        .col-2
          i.custom.iconClose(
            @click="closeModel()"
          )
    .p-3.h-100.overflow-auto(
      style="padding-top: 60px!important;"
    )
      h5.font-weight-bold 新增名單
      .content.mb-3
        b-input-group.mb-3
          b-form-input(
            v-model="searchInput",
            placeholder="請輸入關鍵字"
            style="border-radius: 20px;background-color: #eee;"
          )
          i.fas.fa-search.position-absolute(
            style="right: 10px; top:10px; font-size:1.2rem; z-index: 12",
            @click="searchHandler()"
            )
        .mb-2
          b-card.customerCard(
            bg-variant="white",
            v-for="(user,index) in filterUsers",
            :key="user.id"
          )
            label.w-100.mb-0(
              :for="`checkbox-group-${index}`"
            )
              .row.no-gutters
                .col-1.d-flex.align-items-center.justify-content-center
                  input.custom_checker(
                    type="checkbox",
                    :id="`checkbox-group-${index}`",
                    :name="`user-${index}`",
                    v-model="selectUsersId",
                    :value="user.member_id"
                  )
                  .input_wrap.d-flex
                    .custom-check-icon.border-black.mr-2
                .col-11
                  .row.align-items-center.no-gutters
                    .col-6.pr-1
                      ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                        :profileUrl="user.picture_url",
                        :style="{ 'width': '80px', 'height': '80px' }"
                      )
                    .col-6.pl-1
                      p.mb-0.font-weight-bold {{ user.line_display_name }}
                      p.mb-0.font-weight-bold {{ user.note_name }}
          infinite-loading.my-2(
            @infinite="infiniteHandler",
            :identifier="infiniteId",
            spinner="bubbles",
            ref="infiniteLoading"
          )
            .cursor-default(slot="no-more") 無更多資料
            .cursor-default(slot="no-results") 無更多資料
            .cursor-default(slot="error") 發生錯誤，請重整重試一次
        p.mb-3(
          v-if="filterUsers.length === 0"
        ) 無可標籤的顧客
    .p-2.position-fixed.w-100(style="background-color: #000; bottom: 0; z-index: 15")
      .d-flex.justify-content-center
        .col-6.pl-2
          button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
            type="button",
            @click="submitHandler()",
            style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #FFF;box-shadow: 0.15rem 0.15rem 0 #00000033;"
          ) 確定
</template>

<script>
import { mapState } from 'vuex';
import IconCloseUrl from '@/assets/images/icon/icon_close.png';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import InfiniteLoading from 'vue-infinite-loading';

const _ = require('lodash');

export default {
  name: 'UsersModel',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  components: {
    ProfilePhotoSticker,
    InfiniteLoading
  },
  data() {
    return {
      iconUrl: {
        IconClose: IconCloseUrl
      },
      showModel: false,
      searchInput: null, // 前端過濾的input
      sendInput: null, // 後端過濾的input
      selectUsersId: [],
      infiniteId: +new Date(),
      mode: null
    };
  },
  mounted() {
    this.$EventBus.$on('openUsersModel', (mode) => {
      if (!mode) return;
      this.mode = mode;
      this.initHandler();
    });
  },
  methods: {
    initHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      // 初始化
      vm.selectUsersId = [];
      vm.$store.commit('sa_label/resetInfiniteLoadingData');

      // 把原本有選擇的人放進來
      _.forEach(vm.selectUsers, (res) => {
        vm.selectUsersId.push(res.member_id);
      });

      vm.$swal.close();
      vm.openModel();
      vm.infiniteId += 1;
    },
    infiniteHandler($state) {
      const vm = this;
      if (!vm.showModel) return;

      let apiTarget;

      switch (vm.mode) {
        case 'ba':
          apiTarget = 'getMemberListHandler';
          break;
        case 'backend':
          apiTarget = 'getBackendMemberListHandler';
          break;
        default:
          break;
      }

      if (!vm.mode || !apiTarget) {
          vm.$swal.fire({
          icon: 'error',
          title: '編輯目標錯誤[Err: Not Has NowSelect]'
        });
        return;
      }

      vm.$store.dispatch(`sa_label/${apiTarget}`, {
        current_page: vm.pagination.current_page + 1,
        per_page: vm.pagination.per_page,
        line_display_name: vm.sendInput
      }).then(() => {
        if (vm.pagination.current_page !== vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
          vm.sendInput = null;
        }
      });
    },
    openModel() {
      this.showModel = true;
    },
    closeModel() {
      this.mode = null;
      this.showModel = false;
    },
    autoSelectHandler() {
      const vm = this;
      if (!vm.selectUsersId || vm.selectUsersId.length === 0) {
        _.forEach(vm.memberList, (user) => {
          vm.selectUsersId.push(user.member_id);
        });
      } else vm.selectUsersId = [];
    },
    submitHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '處理中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          vm.$swal.showLoading();
        }
      });

      const selectUsersArr = [];

      _.forEach(vm.memberList, (res) => {
        if (vm.selectUsersId.indexOf(res.member_id) !== -1) {
          selectUsersArr.push(res);
        }
      });

      vm.$store.commit('sa_label/setSelectUsers', selectUsersArr);
      vm.$swal.close();
      vm.closeModel();
    },
    searchHandler() {
      const vm = this;
      if (vm.searchInput) {
        vm.sendInput = vm.searchInput;
      }
      vm.searchInput = null;
      vm.initHandler();
    }
  },
  computed: {
    ...mapState({
      memberList: (state) => state.sa_label.memberList,
      selectUsers: (state) => state.sa_label.selectUsers,
      pagination: (state) => state.sa_label.pagination
    }),
    filterUsers() {
      const vm = this;
      if (!vm.searchInput || vm.searchInput === '') {
        return vm.memberList;
      }
      return vm.memberList.filter((user) => user.line_display_name.includes(vm.searchInput));
    }
  },
  beforeDestroy() {
    this.$EventBus.$off('openUsersModel');
  }
};
</script>

<style lang="scss" scoped>
.card {
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid #d0cdcd;
  &-hasNews {
    &::after {
      content: "";
      position: absolute;
      right: 0.4rem;
      top: 0.4rem;
      background-color: #ef4852;
      width: 0.7rem;
      height: 0.7rem;
      border-radius: 50%;
    }
  }
}

.ProfilePhotoSticker {
  border: 0.2rem solid #000!important;
}
@font-face {
  font-family: "icon";
  src: url("../../assets/fonts/icon.eot?hrpp7d");
  src: url("../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

i.custom {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 1.2rem;
  margin-bottom: 4px;
}

.iconClose:before {
  content: "\e908";
}

.border-black{
  border: 0.2rem solid #000;
}
.outline-invitation {
  display: block;
  border-radius: 1rem;
  padding: 1rem;
  cursor: pointer;
}
.custom-shadow {
  -webkit-box-shadow: 0.2rem 0.2rem 0 #00000033;
  box-shadow: 0.2rem 0.2rem 0 #00000033;
}

.custom-check-icon {
  width: 2rem;
  height: 2rem;
  background-color: #fff;
  border-radius: 0.4rem;
  margin-right: 1.2rem;
  position: relative;
}

.custom_checker:checked ~ .input_wrap .custom-check-icon {
  background-color: #ef4852;
}

.custom_checker:checked ~ .input_wrap .custom-check-icon::after {
  display: block;
}

.custom-check-icon::after {
  content: '';
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 1.5rem;
  height: 1rem;
  background-image: url(../../assets/images/icon/check-1.png);
  background-size: 1.5rem;
  background-repeat: no-repeat;
}

.invitation_info {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

input[type="checkbox"], input[type="radio"] {
  position: absolute;
  width: 1px;
  height: 1px;
  display: none;
  opacity: 0;
}
</style>
